






























import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '../Icon.vue'

@Component({
  components: {
    Icon
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    }
  }
})
export default class InputPassword extends Vue {
  type: string = 'password'

  toggleTextVisibility () {
    this.type = this.type === 'password'
      ? 'text'
      : 'password'
  }
}
